import React from 'react';

// Components
import DashboardLayout from '../_layout/DashboardLayout/dashboard.layout';
import { ManageAgeGroupGraphQL } from '../../AgeGroup/ManageAgeGroup/manage-age-group.graphql';

interface IManageAgeGroupPage {
  match: any;
}

export const ManageAgeGroupPage: React.FC<IManageAgeGroupPage> = ({ match }) => {
  const { ageGroupId } = match.params;

  return (
    <DashboardLayout hideSidebar>
      <ManageAgeGroupGraphQL ageGroupId={ageGroupId} />
    </DashboardLayout>
  );
};
